import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useContext } from 'react'
import { PmiDetails } from './PmiDetails'
import { Waypoint } from 'react-waypoint'
import { useSelector } from 'react-redux'
import { AsyncPanel, Panel } from '../../..'
import { RootState } from '../../../../store'
import { PmiHeaderText } from './PmiHeaderText'
import { PmiProgressBar } from '../PmiProgressBar'
import QuestionSingle from '../../Questions/Single'
import { QUESTIONS } from '../../../../constants/messages'
import { useAmplitudeDebounceSetters } from '../../../../hooks/tracking'
import { MORTGAGE_INSURANCE_TOPIC_KEY } from '../../../../constants/topicKeys'
import { TimelineForRemovalRainbowText } from './TimelineForRemovalRainbowText'

export const ProvidedPmiModule = () => {
  const { ampli } = useContext(AmplitudeContext)
  const ltcvPercent = useSelector<RootState, number>(
    state => state.pmi.ltcvPercent
  )
  const showPmiProvidedModule = useSelector<RootState, boolean | null>(
    state => state.pmi.showPmiProvidedModule
  )
  const [trackModuleViewed] = useAmplitudeDebounceSetters(() =>
    ampli?.moduleViewed({
      module_name: AmplitudeEventConstants.PRIVATE_MORTGAGE_INSURANCE,
    })
  )

  if (!showPmiProvidedModule) {
    return null
  }

  return (
    <AsyncPanel show={showPmiProvidedModule} dataQa='pmi-learn-more-module'>
      <Panel.Heading marginBottom='spacing-800'>
        <PmiHeaderText />
      </Panel.Heading>
      <TimelineForRemovalRainbowText />
      <PmiProgressBar ltcvPercent={ltcvPercent} />
      <PmiDetails ltcvPercent={ltcvPercent} />
      <Waypoint onEnter={trackModuleViewed} />
      <Panel.Footer>
        <QuestionSingle
          topicKey={MORTGAGE_INSURANCE_TOPIC_KEY}
          topic={QUESTIONS.mortgageInsuranceTopic}
          question={QUESTIONS.mortgageInsuranceFooterV2}
        />
      </Panel.Footer>
    </AsyncPanel>
  )
}
